import { Box, CircularProgress } from '@mui/material';
import classNames from 'classnames';

import styles from './Spinner.module.scss';

type SpinnerPropsType = {
  spinnerClassName?: string;
  fixed?: boolean;
  small?: boolean;
  transparent?: boolean;
};

export default function Spinner(props: SpinnerPropsType): JSX.Element {
  const { fixed = false, small = false, spinnerClassName, transparent = false } = props;
  return (
    <Box
      className={classNames(styles.root, {
        [styles.spinnerFixed]: fixed,
        [styles.small]: small,
        [styles.transparent]: transparent,
      })}
    >
      <CircularProgress className={classNames(styles.spinner, spinnerClassName)} />
    </Box>
  );
}
